import {createSlice} from '@reduxjs/toolkit';

const initialUserDetailsState = {
  listLoading: false,
  actionsLoading: false,
  user: null,
  userDataHistory: null,
  lastError: null
};
export const callTypes = {
  list: 'list',
  user: 'user',
  action: 'action'
};

export const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: initialUserDetailsState,
  reducers: {
    userFetched: (state, action) => {
      const {user} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.user = user;
    },
    userDataHistoryFetched: (state, action) => {
      const {userDataHistory} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.userDataHistory = userDataHistory;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.user) {
        state.user = null;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.usersError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
